import React, { useState, useEffect } from 'react'

import { useParams, useNavigate } from 'react-router'
import { Spinner } from 'src/components/__legacy__/spinner/spinner'
import { loginPathWithSSOParam } from 'src/features/auth/utils/loginPathWithSSOParam'
import { trialIdParamName } from 'src/legacy_modules/dashboard/trial/detail/trial-detail'
import { routes } from 'src/legacy_modules/routes'

import { Authenticate } from './authenticate'
import { submitAuthenticate } from './request'

export const membersParamName = 'members'
export const memberIdParamName = 'memberUid'
export const tokenParamName = 'token'

export const AuthenticateContainer = () => {
  const navigate = useNavigate()
  const {
    trialUid = '',
    members = '',
    memberUid = '',
    token = '',
  } = useParams<{
    [trialIdParamName]: string
    [membersParamName]: string
    [memberIdParamName]: string
    [tokenParamName]: string
  }>()
  const [requesting, setRequesting] = useState(true)
  const [message, setMessage] = useState('')

  useEffect(() => {
    ;(async () => {
      try {
        const { email, requiredPasswordChange, loginMethod } =
          await submitAuthenticate({
            trialUid,
            members,
            memberUid,
            token,
          })

        // 本パスワード登録済みの場合、「ログインページ」へ
        if (!requiredPasswordChange) {
          // SSOユーザーはパスワードを持たないため、有効化完了を伝えてSSOログインへ誘導する
          // 遷移先はSSOパラメータ付きにする。付けないとdctでSSOログインボタンが出ない
          if (loginMethod === 'MicrosoftEntraID') {
            navigate(loginPathWithSSOParam(), {
              state: { ssoAccountActivated: true },
            })
            return
          }

          navigate(routes.login)
          return
        }

        // 本パスワード未登録場合、「仮パスワードによるログインページ」へ
        navigate(routes.temporaryPasswordLogin, { state: { email } })
      } catch (error) {
        setMessage(error.message || '問題が発生しました')
      } finally {
        setRequesting(false)
      }
    })()
  }, [memberUid, members, navigate, token, trialUid])

  if (requesting) return <Spinner />

  return <Authenticate message={message} />
}
